<app-header headerText="Lista De Colaboradores"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true *ngIf="readyToSearch">

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon class="bb-check-icon">check</mat-icon>
      Activos<br>&nbsp;
    </ng-template>

    <h5 class="text-center">
      Puede buscar Colaboradores por nombre, apellido, correo o número de Colaborador
    </h5>

    <div class="row">

      <div class="col-md-4 offset-md-4">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="Búsqueda:" [value]="stateSearchBox.query" (input)="handleChange($event.target.value)">
        </mat-form-field>
      </div>

    </div>

    <div *ngIf="dataSource && dataSource.data && dataSource.data.length > 0; else emptySearch">

      <div class="row mt-4">

        <div class="col-md-12">

          <mat-table [dataSource]="dataSource" matSort class="table border">

            <ng-container matColumnDef="employeeNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeNumber}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Correo<br>Electrónico:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="username">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.username }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="company">
              <mat-header-cell *matHeaderCellDef>Compañía</mat-header-cell>
              <mat-cell *matCellDef="let element">{{ element.company }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="details" class="center-text">
              <mat-header-cell *matHeaderCellDef><span>Ver Información<br>Completa</span></mat-header-cell>
              <mat-cell *matCellDef="let element">

                <button mat-icon-button color="primary" [routerLink]="['dashboard', element.employeeNumber]">
                  <mat-icon aria-label="Download">accessibility</mat-icon>
                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>

        </div>

      </div>

      <div class="row mt-4" >

        <div class="col-lg-6 offset-lg-3 py-5 d-flex">

          <ul class="pagination mx-auto">
            <li *ngFor="let page of pages" class="page-item" [ngClass]="{'active': page === statePagination.currentRefinement}">
              <a class="page-link" (click)="statePaginationRefine(page)">
                {{page + 1}}
              </a>
            </li>
          </ul>

        </div>

      </div>

    </div>

    <ng-template #emptySearch>

      <div class="row mt-4">
        <div class="col-md-12 text-center noActions">
          <mat-icon aria-hidden="true">search</mat-icon>
          <h5>Búsqueda sin resultados</h5>
        </div>
      </div>

    </ng-template>



  </mat-tab>

</mat-tab-group>